var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kyc-chart-statistics"},_vm._l((_vm.statistics),function(item,index){return _c('kyc-chart-statistics-item',_vm._b({key:index},'kyc-chart-statistics-item',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }